import Component from "@glimmer/component";
import { isTesting } from "discourse/lib/environment";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class DFloatPortal extends Component {
  get inline() {
    return this.args.inline ?? isTesting();
  }
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.inline}}\n      {{yield}}\n    {{else}}\n      {{#in-element @portalOutletElement insertBefore=null}}\n        {{yield}}\n      {{/in-element}}\n    {{/if}}\n  ", {
      strictMode: true
    }), this);
  }
}